<!-- Search Field -->
<tyl-form-field label="Available Fields" style="width: calc(100% - 25px)">
	<input matInput type="text" name="Available Fields" id="availableFieldsField" [(ngModel)]="searchString" (keydown)="$event.key.toLowerCase() == 'enter' ? sendSearch() : null"
	 (keyup)="getAutofills()" (blur)="sendSearch()" [matAutocomplete]="auto">
	<button mat-icon-button *ngIf="searchString != ''" (click)="searchString = ''; $event.stopPropagation();" style="color: gray;" matSuffix>
		<mat-icon>
			<i [ngClass]="'tyl-ico-fa-times'" aria-hidden="true"></i>
		</mat-icon>
	</button>
</tyl-form-field>

<!-- Search Button -->
<button style="background-color: inherit; border: none;" (click)="sendSearch()">
	<img src="./assets/images/search normal.png" alt="Search" title="Search" style="width: 25px; height: 25px;" />
</button>

<!-- Autocomplete Options -->
<mat-autocomplete #auto="matAutocomplete">
	<mat-option *ngFor="let option of autofills" [value]="option.applyString">
		{{option.displayString}}
	</mat-option>
</mat-autocomplete>